import { Box, Image, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import BankImg1 from 'src/assets/images/bank-1.png'
import BankImg2 from 'src/assets/images/bank-2.png'
import BankImg3 from 'src/assets/images/bank-3.png'
import KlarnaLogo from 'src/assets/images/klarna.svg'

const KlarnaPaymentsInfo = () => {
  const logoWidth = useBreakpointValue({ base: '158px', sm: '168px', md: '226px' })
  const logoHeight = useBreakpointValue({ base: '36px', sm: '46px', md: '51px' })
  const logoMarginBottom = useBreakpointValue({ base: '-18px', sm: '-18px', md: '-25px' })
  const logoPadding = useBreakpointValue({ base: '16px', sm: '16px', md: '24px' })
  const containerPadding = useBreakpointValue({ base: '40px 16px', md: '56px 110px' })
  const gridTemplate = useBreakpointValue({ base: '1fr', md: 'repeat(3, auto)' })

  return (
    <Box
      display='flex'
      flexDirection='column'
      my={{ base: '48px', md: '160px 110px' }}
      maxWidth='90%'
      mx='auto'
    >
      <Box
        alignSelf='center'
        w={logoWidth}
        h={logoHeight}
        mb={logoMarginBottom}
        bgColor='white'
        p={logoPadding}
        zIndex='1'
      >
        <Image src={KlarnaLogo} alt='Klarna Logo' w='100%' />
      </Box>
      <Box
        display='grid'
        gridTemplateColumns={gridTemplate}
        gap='8px'
        w='100%'
        p={containerPadding}
        justifyContent='center'
        alignItems='center'
        border='1px solid #6F6F6F'
      >
        <Image src={BankImg1} alt='Bank 1' maxW='100%' />
        <Image src={BankImg2} alt='Bank 2' maxW='100%' />
        <Image src={BankImg3} alt='Bank 3' maxW='100%' />
      </Box>
    </Box>
  )
}

export default KlarnaPaymentsInfo
